import FloatingSelect from './FloatingSelect'

export default FloatingSelect
